var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.7,190H308c5.7-6,9.2-14.1,9.2-23.1c0-18.4-15-33.4-33.4-33.4c-11.6,0-21.8,5.9-27.8,14.9c-6-9-16.2-14.9-27.8-14.9 c-18.4,0-33.4,14.9-33.4,33.4c0,8.9,3.5,17.1,9.2,23.1h-92.7c0,24.6,21.4,44.5,46,44.5h-1.5c0,24.6,19.9,44.5,44.5,44.5 c0,8,2.1,15.4,5.8,21.9l-36.9,36.9l28.3,28.3l40.2-40.2c1.6,0.6,3.2,1,4.9,1.4l-24.3,54.8L256,423l37.7-40.8l-24.3-54.8 c1.7-0.3,3.3-0.8,4.9-1.4l40.2,40.2l28.3-28.3l-36.9-36.9c3.7-6.5,5.8-13.9,5.8-21.9c24.6,0,44.5-19.9,44.5-44.5h-1.5 C379.3,234.5,400.7,214.6,400.7,190L400.7,190z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/al.26c1cda0259515040e734d066930ae8d.svg";
export { ForwardRef as ReactComponent };